import { DeviceCategory } from "./DeviceCategory";
import { Iterable } from "../Utils/ObjUtils";
import { Dictionary } from "../Utils/Dictionary";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";

export class DeviceCategoriesEntry {
	public Category: DeviceCategory;
	public SourceName: string;
	public SourceDetails: string;

	constructor(category?:DeviceCategory, sourceName?:string, sourceDetails?:string) {
		this.Category = category;
		this.SourceName = sourceName||'';
		this.SourceDetails = sourceDetails||'';
	}

	public get HasSourceName(): boolean	{
		return !!this.SourceName;
	}

	public get HasSourceDetails():boolean {
		return !!this.SourceDetails;
	}

	public Equals(obj:any):boolean {
		if (obj == null)
			return false;
		if (obj == this)
			return true;
		if (!(obj instanceof DeviceCategoriesEntry))
			return false;
		var other = <DeviceCategoriesEntry>obj;
		return (this.Category.Equals(other.Category) &&
			this.SourceName == other.SourceName &&
			this.SourceDetails == other.SourceDetails);
	}
}

//export interface DeviceCategoryJson {
//	device_category: string;
//	source_name: string;
//	source_details: string;
//}

//export interface CategoryEntryJson {
//	entry: DeviceCategoryJson;
//}

//export interface DeviceCategoriesJson {
//	entries: CategoryEntryJson[];
//}

export class DeviceCategories implements Iterable<DeviceCategoriesEntry>, ObjectSerializer {
		
	//public static FromJson(json: DeviceCategoriesJson, network: Network): DeviceCategories {
	//	var result = new DeviceCategories();

 //       if (json !== undefined && json.entries !== undefined)
	//		json.entries.forEach((entry) => {
	//			result.Add(DeviceCategory.Get(entry.entry.device_category), entry.entry.source_name, entry.entry.source_details);
	//		});

	//	return result;
	//}

	private _Entries: Dictionary<DeviceCategory, DeviceCategoriesEntry>;
	private _TestEntry: DeviceCategoriesEntry;

	constructor() {
		this._Entries = new Dictionary<DeviceCategory, DeviceCategoriesEntry>();
		this._TestEntry = new DeviceCategoriesEntry();
	}

	public get Count(): number {
		return this._Entries.Count;
	}

	public Copy(): DeviceCategories {
		let copy = new DeviceCategories();
		this.ForEach((entry: DeviceCategoriesEntry) => {
			copy.Add(entry.Category, entry.SourceName, entry.SourceDetails);
		}, this);
		return copy;
	}
		
	public Add(category: DeviceCategory, sourceName: string, sourceDetails: string) :boolean {
		if (!this._Entries.ContainsKey(category)) {
			var entry = new DeviceCategoriesEntry(category, sourceName, sourceDetails);
			this._Entries.Add(category, entry);
			return true;
		}
		else {
			return false;
		}
	}

	public Remove(category: DeviceCategory): boolean {
		return this._Entries.Remove(category);
	}

	public Find(category: DeviceCategory): DeviceCategoriesEntry {
		return this._Entries.Item(category);
	}

	public FindByName(categoryName: string): DeviceCategoriesEntry {

		var foundEntry:DeviceCategoriesEntry = null;

		this._Entries.Some((pair) => {
			var entry: DeviceCategoriesEntry = pair.Value;
			if (entry.Category == null)
				return;

			if (entry.Category.Name != categoryName)
				return;

			foundEntry = entry;
			return true;
		});

		return (foundEntry);
	}

	private static _OrderedPrimaryCategories: DeviceCategory[] = [
		DeviceCategory.Firewall,
		DeviceCategory.AciSpine,
		DeviceCategory.AciLeaf,
		DeviceCategory.Router,
		DeviceCategory.Stack,
		DeviceCategory.Switch,
		DeviceCategory.Printer,
		DeviceCategory.Firewall,
		DeviceCategory.WirelessController,
		DeviceCategory.WirelessAp,
		DeviceCategory.IpPhone,
		DeviceCategory.IpPhoneManager,
		DeviceCategory.Server,
		DeviceCategory.Workstation,
		DeviceCategory.Windows,
		DeviceCategory.WindowsServer
	]

	public get PrimaryDeviceCategory(): DeviceCategory {
		var result:DeviceCategory = null;

		DeviceCategories._OrderedPrimaryCategories.some((category) => {
			if (this.Contains(category)) {
				result = category;
				return true;
			}
		});

		return result;
	}

	public Clear() {
		this._Entries.Clear();
	}

	public Contains(category: DeviceCategory): boolean {
		return this._Entries.ContainsKey(category);
	}

	public ContainsAll(categories: Iterable<DeviceCategory>): boolean {
		return categories.Every((category) => {
			return this.Contains(category);
		});
	}

	public ContainsSome(categories: Iterable<DeviceCategory>): boolean {
		return categories.Some((category) => {
			return this.Contains(category);
		});
	}

	public Equals(obj: any): boolean {
		if (obj == null)
			return false;
		if (obj == this)
			return true;
		if (!(obj instanceof DeviceCategories))
			return false;

		var other = <DeviceCategories>obj;

		if (this._Entries.Count != other._Entries.Count)
			return false;

		return this._Entries.Every((pair) => {
			var hisEntry = other._Entries.Item(pair.Key);
			return hisEntry && hisEntry.Equals(pair.Value);
		});
	}

	public ForEach(callbackfn: (value: DeviceCategoriesEntry, index: number, array: DeviceCategoriesEntry[]) => void, thisArg?: any): void {
		this._Entries.Values().ForEach(callbackfn, thisArg);
	}

	public Some(callbackfn: (value: DeviceCategoriesEntry, index: number, array: DeviceCategoriesEntry[]) => boolean, thisArg?: any): boolean {
		return this._Entries.Values().Some(callbackfn, thisArg);
	}

	public Every(callbackfn: (value: DeviceCategoriesEntry, index: number, array: DeviceCategoriesEntry[]) => boolean, thisArg?: any): boolean {
		return this._Entries.Values().Every(callbackfn, thisArg);
	}

	public Write(obj: any, context: any): void {
		obj.device_categories = {};
		obj = obj.device_categories;

		if (this._Entries.Count > 0) {
			obj.entries = [];
			ObjSerUtils.WriteCollection(obj.entries, this._Entries.Values(), (entry: DeviceCategoriesEntry) => {
				let elem: any = {
					entry: {
						device_category: entry.Category.toString()
					}
				};
				if (entry.HasSourceName) {
					elem.entry.source_name = entry.SourceName;
				}
				if (entry.HasSourceDetails) {
					elem.entry.source_details = entry.SourceDetails;
				}
				return elem;
			}, context);
		}
	}

	public Read(obj: any, context: any): void {
		this.Clear();

		if (!obj.device_categories)
			throw new Error();
		obj = obj.device_categories;

		if (obj.entries !== undefined) {
			obj.entries.forEach((elem: any) => {
				let category = DeviceCategory.Get(elem.entry.device_category);
				let sourceName = elem.entry.source_name;
				let sourceDetails = elem.entry.source_details;

				this.Add(category, sourceName, sourceDetails);
			}, this);
		}
	}
}
